import { colors, TableHeader, TableHeading } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableHeaderStyled = styled(TableHeader)`
  border-bottom: none;
`;

export const TableHeadingStyled = styled(TableHeading)`
  padding: 1.6rem 0;
  background-color: ${colors.neutral[100]};
  border-bottom: none;

  &:first-child {
    padding-left: 2.4rem;
    padding-right: 1rem;
  }

  &:last-child {
    padding-right: 2.4rem;
  }
`;
